<template>
  <section class="row position-relative Section Section--products" style="margin-top: 7em">

    <div class="col-md-7 Reveal--left">
      <h2 class="Product-title">Multitouch Platforms</h2>
      <div class="row">
        <div class="col-lg-10">
          <ul Class="ProductList">
            <li 
              class="ProductList-item Highlight--emerald"
              v-for="(product, i) in products"
              :key="'productList-' + i"
              :class="{ 'Highlight': currentProductIndex === i }"
              @click="currentProductIndex = i">
              {{ product.name }}
            </li>
          </ul>
        </div>
      </div>
      
      <transition name="fade" mode="out-in">
        <app-slider 
          v-for="(product, i) in products" 
          v-if="currentProductIndex === i"
          :key="'product-' + i"
          :id="product.name"
          :imageLs="[product.images]"
          :classes="[ 'Intrinsic-wrapper--square' ]"/>
      </transition>

    </div>

    <div class="col-md-5 pl-lg-5 pl-md-4 Product">
      <p class="Product-category Reveal--sequenced--right">
        {{ products[currentProductIndex].name }}
      </p>
      <h3 class="Product-subtitlte Reveal--sequenced--right">
        {{ products[currentProductIndex].title }}
      </h3>
      <p class="Product-body Reveal--sequenced--right">
        {{ products[currentProductIndex].body }}
      </p>
          <a 
            class="Button Button--emerald Reveal--sequenced--right"
            target="_blank" 
            rel="noopener"
            :href="products[currentProductIndex].links[0].href"
            :title="products[currentProductIndex].links[0].title">
            <span class="Button-text">{{ products[currentProductIndex].links[0].title }}</span>
          </a>
    </div>

    <div class="Background Background--light" style="top: -35%; left: -10%; width: 100%; height: 170%"></div>

  </section>
</template>

<script>
import products from './../../static/data/products.json'
import appSlider from './Slider'
import KeyMixin from './../mixins/key'
export default {
  components: {
    appSlider
  },

  mixins: [ KeyMixin ],

  data () {
    return {
      currentProductIndex: 0,
      products
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Product {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 4em 0 0 0;
}

.Product-body {
  margin: 0 0 2.5em 0;
}

.Product-category {
  font-family: $fontPrimary;
  position: relative;
  text-transform: uppercase;
  &::after {
    background-color: $colorEmerald;
    content: '';
    position: absolute;
    left: 0;
    bottom: -100%;
    width: 50%;
    height: 8px;
  }
}

.Product-subtitlte {
  font-family: $fontPrimary;
  font-size: 28px;
  font-weight: 400;
  margin: 2.5em 0 1.5em 0;
}

.Product-title {
  margin: 0 0 -.5em 0;
}

.ProductList {
  display: flex;
  flex-wrap: wrap;
  margin: 1em 0 1.5em 0;
  padding: 0;
}

.ProductList-item {
  cursor: pointer;
  display: inline-block;
  font-family: $fontPrimary;
  margin: 1em 1.5em 0 0;
  text-transform: uppercase;
  transition: $transitionPrimary;
  &:hover {
    color: $colorEmerald;
  }
  @media screen and (max-width: $grid-lg) {
    margin: 1em 1em 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue